import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  delete_calendar_event_action,
  get_calendar_event_lists_action,
  get_calendar_past_scheduled_event_lists_action,
  get_calendar_upcoming_scheduled_event_lists_action,
} from "../../../../redux/_actions";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../../_uiComponents/ShowMessageSnack";

function useCalendarDashboard() {
  const [calendarEventLists, setCalendarEventLists] = useState([]);
  const [calendarUpcomingInterviews, setCalendarUpcomingInterviews] = useState(
    []
  );
  const [calendarPastInterviews, setCalendarPastInterviews] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [pastEventsLoading, setPastEventsLoading] = useState(false);
  const [upcomingEventsLoading, setUpcomingEventsLoading] = useState(false);
  const [eventsNextPage, setEventsNextPage] = useState(1);
  const [upcomingEventsNextPage, setUpcomingEventsNextPage] = useState(1);
  const [pastEventsNextPage, setPastEventsNextPage] = useState(1);
  const [activeTab, setActiveTab] = useState(null);

  const { calendarEventListsData } = useSelector(
    (state) => state.get_calendar_event_lists_data_reducer
  );
  const { calendarUpcomingScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_upcoming_scheduled_event_lists_data_reducer
  );
  const { calendarPastScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_past_scheduled_event_lists_data_reducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventsRef = useRef();
  const pastEventsRef = useRef();
  const upcomingEventsRef = useRef();
  const location = useLocation();

  useEffect(() => {
    callEventListsApi();
    callPastScheduledEventsApi();
    callUpcomingScheduledEventsApi();
  }, []);

  useEffect(() => {
    const handleActiveTab = () => {
      const activeTabName = location?.state && location.state?.activeTab;
      if (activeTabName) setActiveTab(activeTabName);
      else {
        setActiveTab("Availability");
      }
    };

    if (location) handleActiveTab(location?.state);
  }, [location]);

  useEffect(() => {
    if (calendarUpcomingScheduledEventListsData?.data) {
      let data = calendarUpcomingScheduledEventListsData.data?.results;
      let results = calendarUpcomingInterviews;
      data.forEach((newItem) => {
        if (
          !results.find((item) => item.interview.id === newItem.interview.id)
        ) {
          results.push(newItem);
        }
      });
      if (calendarUpcomingScheduledEventListsData.data?.next !== null)
        setUpcomingEventsNextPage(upcomingEventsNextPage + 1);
      setCalendarUpcomingInterviews(results);
    }


  }, [calendarUpcomingScheduledEventListsData]);

  useEffect(() => {
    if (calendarPastScheduledEventListsData?.data) {
      let data = calendarPastScheduledEventListsData.data?.results;
      let results = calendarPastInterviews;
      data.forEach((newItem) => {
        if (
          !results.find((item) => item.interview.id === newItem.interview.id)
        ) {
          results.push(newItem);
        }
      });
      if (calendarPastScheduledEventListsData.data?.next !== null)
        setPastEventsNextPage(pastEventsNextPage + 1);
      setCalendarPastInterviews(results);
    }
  }, [calendarPastScheduledEventListsData]);

  useEffect(() => {
    if (calendarEventListsData?.data) {
      let data = calendarEventListsData.data?.results;
      if (calendarEventListsData.data?.next === null) {
        setCalendarEventLists(data);
      } else {
        setEventsNextPage(eventsNextPage + 1);
        let results = calendarEventLists;
        data.forEach((newItem) => {
          if (!results.find((item) => item.id === newItem.id)) {
            results.push(newItem);
          }
        });
      }
    }
  }, [calendarEventListsData]);

  const callEventListsApi = async () => {
    setEventsLoading(true);
    await dispatch(get_calendar_event_lists_action(eventsNextPage));
    setEventsLoading(false);
  };

  const callUpcomingScheduledEventsApi = async () => {
    setUpcomingEventsLoading(true);
    await dispatch(
      get_calendar_upcoming_scheduled_event_lists_action(upcomingEventsNextPage)
    );
    setUpcomingEventsLoading(false);
  };

  const callPastScheduledEventsApi = async () => {
    setPastEventsLoading(true);
    await dispatch(
      get_calendar_past_scheduled_event_lists_action(pastEventsNextPage)
    );
    setPastEventsLoading(false);
  };

  const onScrollUpcomingEvents = () => {
    if (upcomingEventsRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        upcomingEventsRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        if (
          calendarUpcomingScheduledEventListsData?.data &&
          calendarUpcomingScheduledEventListsData.data?.next !== null
        )
          setUpcomingEventsNextPage(upcomingEventsNextPage + 1);
      }
    }
  };

  const onScrollPastEvents = () => {
    if (pastEventsRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = pastEventsRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        if (
          calendarPastScheduledEventListsData?.data &&
          calendarPastScheduledEventListsData.data?.next !== null
        )
          setPastEventsNextPage(pastEventsNextPage + 1);
      }
    }
  };

  const onScrollEvents = () => {
    if (eventsRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = eventsRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        if (calendarEventListsData.data?.next !== null)
          setEventsNextPage(eventsNextPage + 1);
      }
    }
  };

  const onAvailabilityClick = () => {
    navigate("/availability");
  };

  const onCreateEventClick = () => {
    navigate("/create-event");
  };

  const onEventDeleteClick = async (id) => {
    await dispatch(delete_calendar_event_action(id));
    callEventListsApi();
  };

  const onEventEditClick = (id) => {
    navigate(`/create-event/${id}`, { state: id });
  };

  const onEventLinkClick = async (id) => {
    if (id !== null) {
      navigate(`/schedule-interview?event_link=${id}`);
    } else showWarningMessage("Assign availability to event.");
  };

  const onJoinHMSClick = (eventId, id) => {
    if (id !== null) {
      navigate(`/scheduled-interview/join-new-event/${eventId}/${id}`);
    }
  };

  const onEventCopyLinkClick = (id) => {
    if (id !== null) {
      const isDev =
        !process.env.NODE_ENV || process.env.NODE_ENV === "development";
      const url = isDev
        ? `http://localhost:3000/schedule-interview?event_link=${id}`
        : `${process.env.REACT_APP_DEV_ROOT_URL}/schedule-interview?event_link=${id}`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Event Link copied ${url}`);
    } else showWarningMessage("Assign availability to event.");
  };

  const onViewProfile = (Joinee) => {
    if (Joinee?.hash_id) {
      if (Joinee?.role === "candidate") {
        navigate(`/view-candidate-profile/${Joinee?.hash_id}`);
      } else if (Joinee?.role === "mentor") {
        navigate(`/mentor-profile/${Joinee?.hash_id}`);
      }
    } else {
      showWarningMessage("Profile details not found");
    }
  };

  const getEventUrl = (url, hash_id) => {
    const newUrl = `${url}/schedule-interview?event_link=${hash_id}`;
    return newUrl;
  }

  return {
    eventsLoading,
    pastEventsLoading,
    upcomingEventsLoading,
    calendarPastInterviews,
    calendarUpcomingInterviews,
    calendarEventLists,
    calendarEventListsData,
    onScrollEvents,
    onScrollPastEvents,
    onScrollUpcomingEvents,
    eventsRef,
    pastEventsRef,
    upcomingEventsRef,
    onEventDeleteClick,
    onEventEditClick,
    onEventLinkClick,
    onEventCopyLinkClick,
    onCreateEventClick,
    onAvailabilityClick,
    onJoinHMSClick,
    onViewProfile,
    activeTab,
    getEventUrl
  };
}

export default useCalendarDashboard;
